import { useCallback, useEffect, useMemo, useRef } from 'react';

import type { GetRowIdParams, GridReadyEvent } from 'ag-grid-community';
import type { AgGridReact } from 'ag-grid-react';

import { HEADER_HEIGHT, ROW_HEIGHT, TOOLTIP_HIDE_DELAY, TOOLTIP_SHOW_DELAY, ROW_HEIGHT_COMPACT } from './constants';

export function useDefaultGridSettings(props?: { compact?: boolean; scale?: number }) {
  const { compact, scale = 1 } = props || {};
  const gridRef = useRef<AgGridReact>(null);
  const getRowId = useMemo(() => (params: GetRowIdParams) => params.data.id, []);

  const onGridReadyHandler = useCallback((event: GridReadyEvent) => {
    event.api.showLoadingOverlay();
  }, []);

  useEffect(() => {
    if (gridRef.current?.api) {
      gridRef.current.api.resetRowHeights();
    }
  }, [compact, scale]);

  return {
    ref: gridRef,
    getRowId,
    onGridReady: onGridReadyHandler,
    rowSelection: 'multiple' as const,
    headerHeight: HEADER_HEIGHT,
    rowHeight: compact ? ROW_HEIGHT_COMPACT * scale : ROW_HEIGHT * scale,
    tooltipShowDelay: TOOLTIP_SHOW_DELAY,
    tooltipHideDelay: TOOLTIP_HIDE_DELAY,
    suppressColumnMoveAnimation: true,
    suppressAnimationFrame: true,
    suppressColumnVirtualisation: true,
    suppressRowVirtualisation: true,
    stopEditingWhenCellsLoseFocus: true,
  };
}
